import { LobbyAlertDto, MaintenanceAlertDto, MaintenanceStatus } from '@repo/common-types';
import { api } from '../api';

export interface MaintenanceWindowRequest {
  title: string;
  description?: string;
  endTime?: Date | string | null;
  startTime?: Date | string | null;
}

export interface MaintenanceWindowResponse {
  title: string;
  description?: string;
  endTime?: Date | string | null;
  startTime?: Date | string | null;
}

export interface MaintenanceConfigResponse {
  alert: MaintenanceAlertDto | null;
  status: MaintenanceStatus | null;
  progress?: MaintenanceProgressResponse;
}

export interface MaintenanceProgressResponse {
  status: string;
  totalTables: number;
  kickedTables: number;
  totalSeats: number;
  kickedSeats: number;
  errors: string[];
  lastUpdated: string;
}

/**
 * Create or activate maintenance window
 */
export const createMaintenanceWindowRest = async (data: MaintenanceAlertDto): Promise<MaintenanceAlertDto> => {
  const response = await api.post<MaintenanceAlertDto>('/v1/api/maintenance/alert', data);
  return response.data;
};

/**
 * Update existing maintenance window
 */
export const updateMaintenanceWindowRest = async (
  data: MaintenanceWindowRequest,
): Promise<MaintenanceWindowResponse> => {
  const response = await api.put<MaintenanceWindowResponse>('/v1/api/maintenance/alert', data);
  return response.data;
};

/**
 * Get current maintenance window
 */
export const getMaintenanceAlertRest = async (): Promise<MaintenanceAlertDto | null> => {
  const response = await api.get<MaintenanceAlertDto>('/v1/api/maintenance/alert');
  return response.data;
};

/**
 * Deactivate maintenance window (delete)
 */
export const deactivateMaintenanceWindowRest = async (): Promise<void> => {
  await api.post('/v1/api/maintenance/alert/deactivate');
};

/**
 * Create or update lobby alert
 */
export const createLobbyAlertRest = async (data: LobbyAlertDto): Promise<LobbyAlertDto> => {
  const response = await api.post<LobbyAlertDto>('/v1/api/maintenance/lobby-alert', data);
  return response.data;
};

export const updateLobbyAlertRest = async (data: LobbyAlertDto): Promise<LobbyAlertDto> => {
  const response = await api.put<LobbyAlertDto>('/v1/api/maintenance/lobby-alert', data);
  return response.data;
};

/**
 * Get current lobby alert
 */
export const getLobbyAlertRest = async (): Promise<LobbyAlertDto | null> => {
  const response = await api.get<LobbyAlertDto>('/v1/api/maintenance/lobby-alert');
  return response.data;
};

/**
 * Delete lobby alert
 */
export const deleteLobbyAlertRest = async (): Promise<void> => {
  await api.delete('/v1/api/maintenance/lobby-alert');
};

/**
 * Get current maintenance configuration
 */
export const getMaintenanceConfigRest = async (): Promise<MaintenanceConfigResponse> => {
  const response = await api.get<MaintenanceConfigResponse>('/v1/api/maintenance/config');
  return response.data;
};

/**
 * Cancel maintenance window
 */
export const cancelMaintenanceWindowRest = async (): Promise<void> => {
  await api.delete('/v1/api/maintenance/window');
};

/**
 * Trigger player kick process
 */
export const kickAllPlayersRest = async (): Promise<MaintenanceProgressResponse> => {
  const response = await api.post<MaintenanceProgressResponse>('/v1/api/maintenance/start');
  return response.data;
};

/**
 * Complete/End maintenance manually
 */
export const completeMaintenanceRest = async (): Promise<void> => {
  const response = await api.post('/v1/api/maintenance/complete');
  return response.data;
};

// Set maintenance as active (usually after kicking all players)
export const setMaintenanceActiveRest = async (): Promise<void> => {
  const response = await api.post('/v1/api/maintenance/set-active');
  return response.data;
};
